
class AuthenticationError extends Error {
    code: string | null;
    constructor(message: string, code: string | null = null) {
      super(message);
      Object.setPrototypeOf(this, AuthenticationError.prototype);
      this.code = code;
    }
  }
  
  export default AuthenticationError
